<script setup lang="ts">
// import DeleteUserForm from '@/views/profile/Partials/DeleteUserForm.vue';
import SectionBorder from '@/components/general/SectionBorder.vue';
import UpdatePasswordForm from '@/views/profile/Partials/UpdatePasswordForm.vue';
import UpdateProfileInformationForm from '@/views/profile/Partials/UpdateProfileInformationForm.vue';
import FeedbackWidget from '@/components/general/FeedbackWidget.vue';
import BankAccountForm from '@/components/banking/BankAccountForm.vue';
import { storeToRefs } from 'pinia';
// import PushNotificationsForm from '@/views/profile/Partials/PushNotificationsForm.vue';
import { clearCacheAndReload } from '@/utils';
import QRCode from '@/components/general/QRCode.vue'
import { USER_ROLES } from '@/types';
import { useToast } from 'primevue/usetoast';

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);
const toast = useToast();
const bankAccountFormRef = ref(null);

// Check if user needs to set up bank account and show toast + scroll
onMounted(() => {
  if (user.value && (user.value.role === USER_ROLES.BUSINESS || user.value.role === USER_ROLES.DRIVER)) {
    // Check if user doesn't have a bank account
    if (!user.value.bank_account) {
      // Show toast notification
      toast.add({
        severity: 'info',
        summary: 'Bank Account Required',
        detail: 'Please set up your bank account to receive payments. Scrolling to the form below...',
        life: 5000
      });

      // Scroll to bank account form after a short delay
      setTimeout(() => {
        if (bankAccountFormRef.value) {
          bankAccountFormRef.value.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 1000);
    }
  }
});
</script>

<template>


  <div class="px-4 md:px-0">
    <div class="py-10 sm:px-6 lg:px-8">
      <div v-if="user">
        <UpdateProfileInformationForm
          :user="user" />

        <SectionBorder />
      </div>

      <!-- Feedback Widget -->
      <FeedbackWidget class="mt-8" />
      <div class="mt-2" v-if="user.role === USER_ROLES.ADMIN">
        <QRCode
          value="https://boxbuddy.me"
          :size="150"
          :show-download="true"
          :show-print="true"
          :download-name="`boxbuddy-${user?.name}`"
          :business-name="user?.name"
          alt="Business QR Code" />
        <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
          Scan this code to share Boxbuddy link with your friends
        </p>
      </div>
      <div class="flex flex-col items-end mt-8">
        <button
          @click="clearCacheAndReload"
          class="px-3 py-2 mr-2 text-sm text-white bg-purple-600 rounded transition hover:bg-purple-700"
          title="Clear Cache & Reload">
          Click to update app
        </button>
        <p class="mt-1 text-sm text-gray-700 dark:text-gray-200">
          You can click this button occasionally to update the app and get the latest features.
        </p>
      </div>
      <div>
        <UpdatePasswordForm class="mt-10 sm:mt-0" />

        <SectionBorder />
      </div>

      <!-- Bank Account Information for Business and Delivery Driver Users -->
      <div v-if="user && (user.role === USER_ROLES.BUSINESS || user.role === USER_ROLES.DRIVER)"
        ref="bankAccountFormRef"
        class="mt-10 sm:mt-0">
        <BankAccountForm />
        <SectionBorder />
      </div>

      <!-- <div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
                    <TwoFactorAuthenticationForm
                        :requires-confirmation="confirmsTwoFactorAuthentication"
                        class="mt-10 sm:mt-0"
                    />

                    <SectionBorder />
                </div> -->

      <!-- <LogoutOtherBrowserSessionsForm :sessions="sessions" class="mt-10 sm:mt-0" /> -->

      <!-- Push Notifications Settings -->
      <!-- <SectionBorder /> -->
      <!-- <PushNotificationsForm class="mt-10 sm:mt-0" /> -->

      <!-- <template v-if="user">
                    <SectionBorder />
                    <DeleteUserForm class="mt-10 sm:mt-0" />
                </template> -->


    </div>
  </div>
</template>
